var React = require('react');

function Email (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"#FFF"},[React.createElement("path",{"d":"M11.227 10.757c-.14.079-.297.117-.453.117-.157 0-.313-.038-.454-.117L.116 5.023v9.735c0 .622.522 1.128 1.168 1.128h18.982c.644 0 1.166-.505 1.166-1.128V5.023l-10.205 5.734z","transform":"translate(5 8)","key":0}),React.createElement("path",{"d":"M10.774 8.999L21.432 3.01V1.184c0-.622-.522-1.127-1.167-1.127H1.284C.639.057.116.56.116 1.184v1.827l10.658 5.988z","transform":"translate(5 8)","key":1})]));
}

Email.defaultProps = {"width":"32","height":"32","viewBox":"0 0 32 32"};

module.exports = Email;

Email.default = Email;
